import React from 'react'
import { CHARACTER_SEPARATOR_IOT_KEY_NAME } from '../CycleChartPreview/constants';
import classNames from 'classnames';

type ComponentProps = {
  data: {
    name: string;
    color: string;
  },
  cycleControllersName: {
    [key: string]: string;
  },
  deviceName: string,
  isHide: boolean;
}

const ItemLegendCycle: React.FC<ComponentProps> = ({
  data,
  cycleControllersName,
  deviceName,
  isHide,
}) => {
  const seriesEntity = data.name.split(CHARACTER_SEPARATOR_IOT_KEY_NAME);
  const controllerSerialNumber = seriesEntity[0];
  const formattedControllerName = cycleControllersName[controllerSerialNumber];
  const className = classNames('c-data-legend-cycle flex flex-nowrap items-center gap-x-1 text-nowrap font-normal', {
    'opacity-25': isHide
  })

  return (
    <li
      key={data.name}
      className={className}
    >
      <span
        style={{
          display: 'inline-block',
          minWidth: '14px',
          height: '14px',
          backgroundColor: `${data.color}`,
        }}
      ></span>
      <span>
        {deviceName}
        {`\t(${formattedControllerName})`}
      </span>
    </li>
  )
};

export default ItemLegendCycle;